const SPECIALTIES_DISPLAY_LIMIT = 12;

type Specialty = {
  label?: string;
};

export const formatSpecialtiesLabel = (specialties?: Specialty[]) =>
  (specialties || [])
    .slice(0, SPECIALTIES_DISPLAY_LIMIT)
    .map((item) => item?.label)
    .filter(Boolean)
    .join(', ');
